module.exports = "https://www.gc-qa.gnp.com.mx/b04c0d2ad86f42c027fe5a98995f6974.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_danos_off.svg
// module id = 692
// module chunks = 0